export const defaultLeg = {
    date: "",
    type: "Single",
    departFrom: "",
    arriveTo: "",
    departureDate: "",
    arrivalDate: "",
    ferry: false,
    aircraft: '',
    payload: "",
    payloadUnit: "kg",
    volume: "",
    volumeUnit: "cbm",
    mdPosition: '',
    ldPosition: ''
}

export const defaultOption = {
    id: null,
    isSelected: false,
    reference: "",
    buildAndBreak: false,
    price: null,
    currency: "usd",
    expiration: "",
    status: "draft",
    legs: [structuredClone(defaultLeg)],
    disclaimers: [],
    attachments: [],
    notes: '',
}

export const defaultQuote = {
    id: "",
    status: 'draft',
    selectedOption: null,
    requestAirline: '',
    airline: {},
    payload: null,
    payloadFormatted: null,
    payloadUnit: null,
    quoteDate: null,
    expiration: null,
    expirationDate: '',
    options: [structuredClone(defaultOption)],
}

export const mockQuoteList = [
  {
    id: '7744XY',
    status: 'draft',
    date: '2025-06-10T00:00:00Z',
    airline: { id: 'LH', name: 'Lufthansa Cargo', logo: '/img/charterers/LH.png' },
    charterer: { id: 'DB', name: 'DB Schenker', code: 'DB', logo: '/img/charterers/DB.png' },
    requestId: '7744XZ',
    expirationDate: '2025-06-30T00:00:00Z',
    flightType: 'multiple',
    options: [
      {
        reference: '7744XY-1',
        buildAndBreak: false,
        price: 21000,
        currency: 'USD',
        status: 'updated',
        legs: [
          {
            departFrom: { iata_code: 'CDG', city: 'Paris' },
            arriveTo: { iata_code: 'FRA', city: 'Frankfurt' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-16T00:00:00Z',
            ferry: false,
            aircraft: 'A330-200F',
            payload: 38000,
            payloadUnit: 'kg',
            volume: 85,
            volumeUnit: 'cbm',
            mdPosition: '',
            ldPosition: ''
          },
          {
            departFrom: { iata_code: 'FRA', city: 'Frankfurt' },
            arriveTo: { iata_code: 'MXP', city: 'Milan' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-16T00:00:00Z',
            ferry: false,
            aircraft: 'A330-200F',
            payload: 38000,
            payloadUnit: 'kg',
            volume: 85,
            volumeUnit: 'cbm',
            mdPosition: '',
            ldPosition: ''
          },
          {
            departFrom: { iata_code: 'MXP', city: 'Milan' },
            arriveTo: { iata_code: 'BCN', city: 'Barcelona' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-16T00:00:00Z',
            ferry: true,
            aircraft: 'A330-200F',
            payload: 0,
            payloadUnit: 'kg',
            volume: 0,
            volumeUnit: 'cbm',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      },
      {
        reference: '7744XY-2',
        buildAndBreak: false,
        price: 20000,
        currency: 'USD',
        status: 'accepted',
        legs: [
          {
            departFrom: { iata_code: 'FRA', city: 'Frankfurt' },
            arriveTo: { iata_code: 'BER', city: 'Berlin' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-16T00:00:00Z',
            ferry: false,
            payload: 32000,
            payloadUnit: 'kg',
            volume: 60,
            volumeUnit: 'cbm',
            mdPosition: '',
            ldPosition: ''
          },
          {
            departFrom: { iata_code: 'BER', city: 'Berlin' },
            arriveTo: { iata_code: 'FRA', city: 'Frankfurt' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-16T00:00:00Z',
            ferry: false,
            payload: 30000,
            payloadUnit: 'kg',
            volume: 55,
            volumeUnit: 'cbm',
            mdPosition: '',
            ldPosition: ''
          },
          {
            departFrom: { iata_code: 'FRA', city: 'Frankfurt' },
            arriveTo: { iata_code: 'JFK', city: 'New York' },
            departureDate: '2025-06-17T00:00:00Z',
            arrivalDate: '2025-06-17T00:00:00Z',
            ferry: false,
            payload: 30000,
            payloadUnit: 'kg',
            volume: 55,
            volumeUnit: 'cbm',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      },
      {
        reference: '7744XY-3',
        buildAndBreak: false,
        price: 19000,
        currency: 'USD',
        status: 'submitted',
        legs: [
          {
            departFrom: { iata_code: 'CDG', city: 'Paris' },
            arriveTo: { iata_code: 'MAD', city: 'Madrid' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-08-22T00:00:00Z',
            ferry: false,
            payload: 60000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      }
    ]
  },
  {
    id: '9846AB',
    status: 'improvement',
    date: '2025-06-10T00:00:00Z',
    airline: { id: 'LH', name: 'Lufthansa Cargo', logo: '/img/charterers/LH.png' },
    charterer: { id: 'CM', name: 'CMA CGM', code: 'CM', logo: '/img/charterers/CM.png' },
    requestId: 'AA12BB',
    expirationDate: '2025-07-01T00:00:00Z',
    flightType: 'single',
    options: [
      {
        reference: '9846AB-1',
        buildAndBreak: false,
        price: 81000,
        currency: 'USD',
        status: 'improvement',
        legs: [
          {
            departFrom: { iata_code: 'FRA', city: 'Frankfurt' },
            arriveTo: { iata_code: 'BER', city: 'Berlin' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-08-11T00:00:00Z',
            ferry: false,
            aircraft: 'B777F',
            payload: 65000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      },
      {
        reference: '9846AB-2',
        buildAndBreak: false,
        price: 79500,
        currency: 'USD',
        status: 'submitted',
        legs: [
          {
            departFrom: { iata_code: 'FRA', city: 'Frankfurt' },
            arriveTo: { iata_code: 'BER', city: 'Berlin' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-17T00:00:00Z',
            ferry: false,
            payload: 60000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      }
    ]
  },
  {
    id: '2847CD',
    status: 'pending_to_view',
    date: '2025-06-10T00:00:00Z',
    airline: { id: 'LH', name: 'Lufthansa Cargo', logo: '/img/charterers/LH.png' },
    charterer: { id: 'NG', name: 'Kuehne Nagel', code: 'NG', logo: '/img/charterers/NG.png' },
    requestId: 'AA12BB',
    expirationDate: '2025-06-28T00:00:00Z',
    flightType: 'single',
    options: [
      {
        reference: '2847CD-1',
        buildAndBreak: false,
        price: 64000,
        currency: 'USD',
        status: 'pending_to_view',
        legs: [
          {
            departFrom: { iata_code: 'ATL', city: 'Atlanta' },
            arriveTo: { iata_code: 'JFK', city: 'New York' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-07-21T00:00:00Z',
            ferry: false,
            aircraft: 'A330-200F',
            payload: 45000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      }
    ]
  },
  {
    id: '3548EF',
    status: 'pending_to_sign',
    date: '2025-06-10T00:00:00Z',
    airline: { id: 'LH', name: 'Lufthansa Cargo', logo: '/img/charterers/LH.png' },
    charterer: { id: 'MP', name: 'Chapman Freeborn', code: 'MP', logo: '/img/charterers/MP.png' },
    requestId: 'AA12BB',
    expirationDate: '2025-07-04T00:00:00Z',
    flightType: 'single',
    options: [
      {
        reference: '3548EF-1',
        buildAndBreak: false,
        price: 57000,
        currency: 'USD',
        status: 'pending_to_sign',
        legs: [
          {
            departFrom: { iata_code: 'MIA', city: 'Miami' },
            arriveTo: { iata_code: 'MEX', city: 'Mexico City' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-09-22T00:00:00Z',
            ferry: false,
            aircraft: 'B737-800F',
            payload: 52000,
            payloadFormatted: '52.000 kg',
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      },
      {
        reference: '3548EF-2',
        buildAndBreak: false,
        price: 58000,
        currency: 'USD',
        status: 'pending_to_sign',
        legs: [
          {
            departFrom: { iata_code: 'MIA', city: 'Miami' },
            arriveTo: { iata_code: 'MEX', city: 'Mexico City' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-17T00:00:00Z',
            ferry: false,
            payload: 52000,
            payloadFormatted: '52.000 kg',
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      },
      {
        reference: '3548EF-3',
        buildAndBreak: false,
        price: 60000,
        currency: 'USD',
        status: 'pending_to_sign',
        legs: [
          {
            departFrom: { iata_code: 'MIA', city: 'Miami' },
            arriveTo: { iata_code: 'MEX', city: 'Mexico City' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-17T00:00:00Z',
            ferry: false,
            payload: 60000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: 'Includes build & breaks'
      }
    ]
  },
  {
    id: '4449GH',
    status: 'accepted',
    date: '2025-06-10T00:00:00Z',
    airline: { id: 'LH', name: 'Lufthansa Cargo', logo: '/img/charterers/LH.png' },
    charterer: { id: 'CM', name: 'CMA CGM', code: 'CM', logo: '/img/charterers/CM.png' },
    requestId: 'AA12BB',
    expirationDate: '2025-07-12T00:00:00Z',
    flightType: 'single',
    options: [
      {
        reference: '4449GH-1',
        buildAndBreak: false,
        price: 85000,
        currency: 'USD',
        status: 'accepted',
        legs: [
          {
            departFrom: { iata_code: 'AMS', city: 'Amsterdam' },
            arriveTo: { iata_code: 'BRU', city: 'Bruselas' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-10-30T00:00:00Z',
            ferry: false,
            aircraft: 'B747-400F',
            payload: 75000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      }
    ]
  },
  {
    id: '6750IJ',
    status: 'expired',
    date: '2025-06-10T00:00:00Z',
    airline: { id: 'LH', name: 'Lufthansa Cargo', logo: '/img/charterers/LH.png' },
    charterer: { id: 'MP', name: 'Chapman Freeborn', code: 'MP', logo: '/img/charterers/MP.png' },
    requestId: 'AA12BB',
    expirationDate: '2025-06-20T00:00:00Z',
    flightType: 'single',
    options: [
      {
        reference: '6750IJ-1',
        price: 80000,
        currency: 'USD',
        status: 'expired',
        legs: [
          {
            departFrom: { iata_code: 'ICN', city: 'Incheon' },
            arriveTo: { iata_code: 'HND', city: 'Tokio' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-17T00:00:00Z',
            ferry: false,
            aircraft: 'B777F',
            payload: 58000,
            payloadFormatted: '58.000 kg',
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      },
      {
        reference: '6750IJ-2',
        buildAndBreak: false,
        price: 82000,
        currency: 'USD',
        status: 'expired',
        legs: [
          {
            departFrom: { iata_code: 'ICN', city: 'Incheon' },
            arriveTo: { iata_code: 'HND', city: 'Tokio' },
            departureDate: '2025-06-16T00:00:00Z',
            arrivalDate: '2025-06-17T00:00:00Z',
            ferry: false,
            payload: 60000,
            payloadUnit: 'kg',
            volume: '',
            volumeUnit: '',
            mdPosition: '',
            ldPosition: ''
          }
        ],
        disclaimers: [
          'quote is subject to prior made commitments and agreement on contract terms',
          'quote is subject to changes in the fuel costs',
          'quote is subject to final aircraft and crew availability',
          'quote is subject to final loadmaster availability',
          'cargo is to be delivered secure and ready for carriage',
          'warehouse cost at origin and destination are included',
          'royalties, local taxes, VAT and/or commissions, if levied, are excluded',
          'quote is subject to final details such as total weight/volume',
          'quote is subject to total shipment being loadable on one flight',
          'quote is subject to final flight time and payload estimation by our flight operation engineers'
        ],
        attachments: [],
        notes: ''
      }
    ]
  }
];